
<div class="p-grid">
    <div class="p-col-12 page-header">Resource Center</div>
    <div class="p-col-12 divider-header">
        <p-divider></p-divider>
    </div>
    <div class="p-col-12">
        <div class="p-grid">
            <div class="p-col-12 p-lg-3 p-md-3 p-sm-3" *ngIf="canAddResource">
                <p-button styleClass="fullwidthbtn" label="New Resource" routerLink="/resource/new"></p-button>
            </div>
            <div class="p-col-12 p-lg-3 p-md-3 p-sm-3" *ngIf="canViewEditResourceCategory">
                <p-button styleClass="fullwidthbtn" label="New Resource Category" (click)="openNew()"></p-button>
            </div>
            <div class="p-col-12 p-lg-5 p-md-5 p-sm-5">
                <input type="text" pInputText [(ngModel)]="searchterm" placeholder="Search Resources">
            </div>
            <div class="p-col-12 p-lg-1 p-md-1 p-sm-1">
                <button pButton type="button" icon="pi pi-search" iconPos="left" (click)="SearchResources($event)"></button>
            </div>
        </div>
    </div>
    <div class="p-col-12" *ngIf="resourcecategories" style="margin-top: -15px;">
        <div class="card">           
            <div class="p-col-12">
                <p-tree [value]="resourcecategories" [style]="{border: 'none'}">
                    <ng-template let-node pTemplate="Child">
                        <a routerLink="/resource-list/{{node.data}}">{{node.label}}</a>
                        <button pButton type="button" pRipple icon="pi pi-trash" class="p-button-sm p-button-text alignMiddle"
                                (click)="DeleteCategory(node)" *ngIf="canViewEditResourceCategory"></button>
                    </ng-template>
                    <ng-template let-node pTemplate="Parent">
                        <b>{{node.label}}</b>
                        <button pButton type="button" pRipple icon="pi pi-trash" class="p-button-sm p-button-text alignMiddle"
                                (click)="DeleteCategory(node)" *ngIf="canViewEditResourceCategory"></button>
                    </ng-template>
                </p-tree>
            </div>
        </div>
    </div>
</div>


<form #f="ngForm" (ngSubmit)="AddResourceCategory()">
   <p-dialog draggable="false" modal="true"  [(visible)]="addcatDialog" [positionTop]="50" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '40vw'}" header="Add Resource Category" [modal]="true" styleClass="p-fluid">
     <div class="p-grid">        
         <div>
             <div class="p-col-12 error-notify-text">
                 <app-validateform [formToValidate]="addCatForm"></app-validateform>
             </div>

             <div class="p-grid">
                 <div class="p-col-12">
                     <span class="p-float-label">
                         <input type="text"
                                pInputText
                                [(ngModel)]="Name"
                                name="Name"
                                requiredNoSpaceValidator
                                data-display-name="Name" />
                         <label for="float-input">Name*</label>
                     </span>
                 </div>

                 <div class="p-col-12">
                     <span class="p-float-label">
                         <input type="text"
                                pInputText
                                [(ngModel)]="Description"
                                name="Description"
                                data-display-name="Description" />
                         <label for="float-input">Description</label>
                     </span>
                 </div>

                 <div class="p-col-12">
                     <span class="p-float-label">
                         <p-dropdown inputId="dropdown"
                                     [autoDisplayFirst]="false"
                                     [showClear]="true"
                                     [options]="parentCategories"
                                     [(ngModel)]="selectedParentCategory"
                                     optionLabel="Name"
                                     name="Parent Category"
                                     appendTo="body"
                                     required
                                     data-display-name="Parent Category">

                         </p-dropdown>
                         <label for="dropdown">Parent Category*</label>
                     </span>
                 </div>

                 <div class="p-col-12" [hidden] = "showParentCatMsg()">
                    <p-message severity="info" text="This option creates a new group of resource categories. Create at least one category in this group to add resources" styleClass="mr-2"></p-message>
                </div>
             </div>           
             <ng-template pTemplate="footer">
                 <button pButton type="submit" class="fullwidthbtn" label="Save"></button>
                 <button pButton type="button" class="fullwidthbtn" label="Cancel" (click)="hideDialog()"></button>
             </ng-template>
         </div>
      
    </div>
    </p-dialog>
</form>

<!-- <form #f="ngForm" (ngSubmit)="AddResourceCategory()">
    <p-dialog draggable="false" modal="true"  [(visible)]="addcatDialog" [positionTop]="50" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}" header="Add Link" [modal]="true" styleClass="p-fluid">
        <ng-template pTemplate="content">
            
            <input type="text"
            pInputText
            [(ngModel)]="message.ContactName"
            name="Name"
            requiredNoSpaceValidator
            data-display-name="Name" />
     <label for="float-input">Name*</label>
            <div class="p-field">
                <label for="Name">Name</label>
                <input type="text" pInputText id="Name" [(ngModel)]="Name" formControlName="Name" required autofocus />
                <small class="p-error" *ngIf="submitted && ngForm.Name == ''">Name is required.</small>
            </div>
            <div class="p-field">
                <label for="Description">Description</label>
                <input type="textarea" pInputText id="Description" formControlName="Description"  [(ngModel)]="Description" required autofocus />                
            </div>
            <div class="p-field">
                <div>
                    <label for="selectedParentCategory">Parent Category</label>
                    <p-dropdown appendTo="body" [options]="parentCategories" [(ngModel)]="selectedParentCategory" optionLabel="Name"></p-dropdown>
                </div>
            </div>
        </ng-template>
        
        <ng-template pTemplate="footer">
            <button pButton type="button" pRipple label="Cancel" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
            <button pButton pRipple type="submit" label="Save" icon="pi pi-check" class="p-button-text"></button>
        </ng-template>
    </p-dialog>
</form> -->
<p-confirmDialog header="Confirmation" key="DeleteResourceCategoryConfirmDialog" icon="pi pi-exclamation-triangle">
</p-confirmDialog>
